<div class="accept-call-dialog">
  <h4>
    <div class="user-header">
      <app-avatar-thumbnail
        [user]="callOptions.initiator"
        size="40"
      ></app-avatar-thumbnail>
      {{ callOptions.initiator.first_name }}
      {{ callOptions.initiator.last_name }}
    </div>
  </h4>

  <div class="phone-ring-container">
    <div class="phone-ring">
      <a href="#">
        <div class="quick-alo-ph-circle"></div>
        <div class="quick-alo-ph-circle-fill"></div>
        <div class="quick-alo-ph-img-circle"></div>
      </a>
    </div>
  </div>

  <div class="message">
    <p>
      {{ (callOptions.audioOnly ? "COMPONENTS.ACCEPT_CALL_DIALOG.REQUESTING_AUDIO" : "COMPONENTS.ACCEPT_CALL_DIALOG.REQUESTING_VIDEO") | translate }}
    </p>
    <p>{{ "COMPONENTS.ACCEPT_CALL_DIALOG.CONFIRM" | translate }}</p>
  </div>

  <div class="call-buttons">
    <button mat-raised-button color="primary" (click)="accept($event)">
      {{ "COMPONENTS.ACCEPT_CALL_DIALOG.ACCEPT" | translate }}
    </button>
    <button mat-raised-button (click)="decline($event)">{{ "COMPONENTS.ACCEPT_CALL_DIALOG.DECLINE" | translate }}</button>
  </div>

  <audio #ringingSound loop="true">
    <source src="assets/sounds/sound_effects.mp3" type="audio/mp3"/>
  </audio>
  <audio #callAcceptedSound>
    <source src="assets/sounds/positive.wav" type="audio/wav"/>
  </audio>
  <audio #callDeclinedSound>
    <source src="assets/sounds/declined.mp3" type="audio/mp3"/>
    <source src="assets/sounds/declined.wav" type="audio/wav"/>
  </audio>
</div>
